import { createSharedState } from '../../../hooks/use-shared-state';

export interface DashboardRemove {
  dashboardId: string;
}

export interface DashboardUpsert {
  id: string | undefined;
  name: string;
}

export interface DashboardList {
  upsert: DashboardUpsert | undefined;
  remove: DashboardRemove | undefined;
}

export function initialDashboardList(): DashboardList {
  return { upsert: undefined, remove: undefined };
}

export function initialDashboardCreate(): DashboardUpsert {
  return { id: undefined, name: '' };
}

export function initialDashboardUpsert(dashboard: { id: string; name: string }): DashboardUpsert {
  return { id: dashboard.id, name: dashboard.name };
}

export const dashboardListState = createSharedState(initialDashboardList());
